import {
    Button,
    Dropdown,
    Menu,
    theme
} from "antd";
import { BsChevronDown } from "react-icons/bs";
import { fy_status } from "../../consts";

export default function FYStatusSelector({
    item, handleStatusUpdate, isDisabled = true
}) {
    const {
        token: { colorPrimary },
    } = theme.useToken();

    const statusColors = {
        [fy_status.OPEN]: colorPrimary,
        [fy_status.QUERIES_PENDING]: "orange",
        [fy_status.QUERIES_RESOLVED]: "green",
        [fy_status.CLOSED]: "red",
    };



    const statusMenu = (
        <Menu
            selectedKeys={[item.status]} // replaces defaultValue
            onClick={({ key }) => handleStatusUpdate(item, key)} // single handler
            items={[
                {
                    key: fy_status.OPEN,
                    label: fy_status.OPEN,
                },
                {
                    key: fy_status.QUERIES_PENDING,
                    label: fy_status.QUERIES_PENDING,
                },
                {
                    key: fy_status.QUERIES_RESOLVED,
                    label: fy_status.QUERIES_RESOLVED,
                },
                {
                    key: fy_status.CLOSED,
                    label: fy_status.CLOSED,
                },
            ]}
        />
    );

    return (
        <Dropdown
            trigger={["click"]}
            overlay={statusMenu}
            arrow
            disabled={isDisabled}
        >
            <Button
                type="text"
                style={{
                    padding: "0px 10px",
                    width: "100%",
                    color: statusColors[item.status],
                }}
            >
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        fontSize: "10px",

                    }}
                >
                    {
                        item.status ? item.status : "Set Status"
                    }
                    {isDisabled ? null : <BsChevronDown />}
                </div>
            </Button>
        </Dropdown>
    );
}